import i18next from 'i18next';
import { useTranslation as usei18nextTranslation } from 'react-i18next';

const NAMESPACE = 'TIME';

i18next.addResources('es', NAMESPACE, {
  TIME_DISTANCE: 'Hace {{distance}}',
  DISTANCE: '{{distance}}',
});

i18next.addResources('en', NAMESPACE, {
  TIME_DISTANCE: '{{distance}} ago',
  DISTANCE: '{{distance}}',
});

i18next.addResources('pt', NAMESPACE, {
  TIME_DISTANCE: 'Há {{distance}}',
  DISTANCE: '{{distance}}',
});

export const useTranslation = () => usei18nextTranslation([NAMESPACE, 'GENERAL']);
